<template>
    <div style="float:left;width:auto;">
        <v-input v-model="cell.Value">
        </v-input>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VInput from '@/components/form/Input'

    export default {
        components: {
            VInput
        },
        props: {
            cell: {
                Value: { type: String, default: "" }, 
                Column : { type: Number, default: 0 },
                Row : { type: Number, default: 0 },
             },
        },
        data() {
            return {}
        },
        methods: {},
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/sizeChart/SizeChartCell.vue